<template>
<!-- eslint-disable max-len -->
<list-page
  name="Character"
  icon
  use="_id"
  :display="display"
  page-prefix="/blade/characters"
  :fetch="getCharacters"
  :remove="deleteCharacter"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getCharacters',
      'deleteCharacter',
    ]),
    display({
      name: characterName,
      avatar,
      narrator,
      challengeIntro,
      scrollImage,
      twoDimensional,
      theme,
      isOldCharacter,
      updated,
    }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';

      let uses = [];
      if (theme) {
        if (theme === 'starfighter') uses.push('Panoramic');
        if (theme === 'native') uses.push('Native');
      }
      if (avatar) uses.push('Avatar');
      if (narrator) uses.push('Narrator');
      if (challengeIntro) uses.push('Section Intro');
      if (scrollImage) uses.push('Scroll Image');
      if (twoDimensional) uses.push('2D');
      uses = uses.length ? `(${uses.join(', ')})` : '';

      return `${(isOldCharacter ? '[NON-CENTRALIZED] ' : '')}${characterName} ${uses} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/CharactersList.vue